import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { NavBar } from "../components/navbar/NavBar";

const Auth = ({ children }: { children: ReactNode }) => {
 // 获取登录状态
 const token = localStorage.getItem("token");
 const location = useLocation();
 
 // 判断
 if (token) {
   // 检查当前路径是否为编辑页面，如果是则不显示NavBar
   const isVideoEditPage = location.pathname.startsWith('/videoEdit/');
   
   return (
     <>
       {!isVideoEditPage && <NavBar />}
       {children}
     </>
   );
 } else {
   return <Navigate to="/login" />;
 }
};

export default Auth;
